export default "__VITE_ASSET__LAKo6hJq__"